import React from 'react';
import styled from 'styled-components';
import schemes from './schemes';
const Fallback = styled.div `
  background-color: var(--base-bg-secondary);
  border-radius: var(--border-r-seed);
  display: inline-block;
  height: 16px;
  width: 26px;
`;
export const getSchemeIcon = (scheme) => {
    return scheme && schemes[scheme.toUpperCase()];
};
export const CardIcon = ({ hasFallback, scheme = '', secondaryScheme, ...rest }) => {
    const Icon = getSchemeIcon(scheme) || getSchemeIcon(secondaryScheme);
    if (Icon) {
        return React.createElement(Icon, { ...rest });
    }
    if (hasFallback) {
        return React.createElement(Fallback, { "data-testid": "fallback-card-icon" });
    }
    return null;
};
